<template>
  <v-container fluid>
    <v-card>
      <v-card-title primary-title>
        <span class="headline mb-0">Shipping Advice</span>
      </v-card-title>
      <v-card-text style="color:red">
        <h3>2018 12 11</h3>
        <ul>
          <li>1） 运输形态后面添加LCL/FCL的选择，一个S/A要么是FCL，要么是LCL</li>

          <li>2） 確定送信，显示在B0500</li>

          <li>3） 添加航次voyage NO</li>

          <li>4） B/L NO 列可以在列表中删除，S/I No可以放在头上</li>
        </ul>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
export default {
  data() {
    return {}
  }
}
</script>
<style scoped>
</style>
